// Definimos la URL base según la variable de entorno, con fallback a localhost
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchHospedajesByEdificio = async (edificioId, { limit = 50, offset = 1, query = {} } = {}) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        limit, 
        offset, 
        query: {
          ...query,
          'edificio.id': edificioId
        }
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los hospedajes');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los hospedajes:', error);
    throw error;
  }
};

export const fetchHospedajes = async ({ limit = 50, offset = 1, query = {} } = {}) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit, offset, query }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los hospedajes');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los hospedajes:', error);
    throw error;
  }
};

export const fetchHospedajeById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener el hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener el hospedaje:', error);
    throw error;
  }
};

export const createHospedaje = async (hospedajeData) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(hospedajeData),
    });

    if (!response.ok) {
      throw new Error('Error al crear el hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear el hospedaje:', error);
    throw error;
  }
};

export const updateHospedaje = async (id, hospedajeData) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, data: hospedajeData }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar el hospedaje:', error);
    throw error;
  }
};

export const deleteHospedaje = async (id) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/delete/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Error al eliminar el hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar el hospedaje:', error);
    throw error;
  }
};
